import React from 'react';
import { Accordion, Box, Copy, Optional } from '@honda-canada/design-system-react';
import BreakdownGroupTitle from './BreakdownGroupTitle';
import themeStyles from './PriceBreakdownModalContent.styles';
import { getBreakdownGroupContentValue } from './usePriceBreakdownGroups';
import { useLanguage } from '../../../utils/sitecoreContext';
const SubSectionGroupItem = themeStyles.apply(Box, 'SubSectionGroupItem');
const SubSectionGroupItemTitle = themeStyles.apply(Copy, 'SubSectionGroupItemTitle');
const SubSectionGroup = ({ content, forPrint, ...props }) => {
    const language = useLanguage();
    return (React.createElement(Box, null,
        React.createElement(Optional, { when: !(content === null || content === void 0 ? void 0 : content.length) },
            React.createElement(BreakdownGroupTitle, { padding: "l", ...props })),
        React.createElement(Optional, { when: content === null || content === void 0 ? void 0 : content.length },
            React.createElement(Accordion, { defaultActiveItems: forPrint && ['SubSectionGroupItem'], iconName: "animatedArrowUpDown", isCompact: true, hasBottomBorder: false, itemsHaveTopBorder: false, activeTitleHasBorder: false, items: [
                    {
                        key: 'SubSectionGroupItem',
                        title: React.createElement(BreakdownGroupTitle, { asAccordion: true, padding: "l", ...props }),
                        content: (React.createElement(Box, null, content === null || content === void 0 ? void 0 : content.map(item => (React.createElement(SubSectionGroupItem, { key: item.title },
                            React.createElement(SubSectionGroupItemTitle, { "data-testid": `${item.dataTestId}-title` }, item === null || item === void 0 ? void 0 : item.title),
                            React.createElement(Box, null,
                                React.createElement(SubSectionGroupItemTitle, { "data-testid": `${item.dataTestId}-value` }, getBreakdownGroupContentValue(item.value, item.unit, language)))))))),
                    },
                ] }))));
};
export default SubSectionGroup;
